import { createSlice } from "@reduxjs/toolkit";
import { getNsdcQuestionThunk,createNsdcQuestionThunk } from "./Manage_Nsdc_Thunk";

const initialState = {
  nsdc_questions: [],
  loading: false,
  status: "",
  message: "",
};

const Manage_Nsdc_Slice = createSlice({
  name: "nsdcquestionsslice",
  initialState,
  reducers: {},
  extraReducers: {
    [getNsdcQuestionThunk.pending]: (state, action) => {
      state.nsdc_questions = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getNsdcQuestionThunk.fulfilled]: (state, action) => {
      state.nsdc_questions = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getNsdcQuestionThunk.rejected]: (state, action) => {
      state.nsdc_questions = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [createNsdcQuestionThunk.pending]: (state, action) => {
   
        state.loading = true;
        state.status = action.meta.requestStatus;
        state.message = "loading";
      },
      [createNsdcQuestionThunk.fulfilled]: (state, action) => {
      
        state.loading = false;
        state.status = action.meta.requestStatus;
        state.message = "success";
      },
      [createNsdcQuestionThunk.rejected]: (state, action) => {
       
        state.loading = false;
        state.status = action.meta.requestStatus;
        state.message = action.error.message;
      },
    
  },
});

export default Manage_Nsdc_Slice.reducer;
